import type { NavigateFunction } from 'react-router'

/**
 * Replaces only the `period` query param on the given search string and navigates to it. `currentSearch` is read
 * by the caller from the live location (rather than from a render snapshot) so a concurrent update to another
 * param (search, sort, filters) made by a neighboring hook is preserved instead of overwritten.
 */
export const replacePeriodSearchParam = (
  navigate: NavigateFunction,
  currentSearch: string,
  encodedPeriod: string,
): void => {
  const searchParams = new URLSearchParams(currentSearch)
  searchParams.set('period', encodedPeriod)
  navigate({ search: searchParams.toString() }, { replace: true })
}
